import cloneDeep from 'lodash/cloneDeep';

import moment from 'moment';

class SystemNote {
  constructor({
    id, systemID, title, note, flag, deleted, lastModified,
  }) {
    this.id = id;
    this.systemID = systemID;
    this.title = title || '';
    this.note = note || '';
    this.flag = flag || false;
    this.deleted = deleted || false;
    this.lastModified = lastModified && moment(lastModified);
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      SystemID: this.systemID,
      Title: this.title,
      Note: this.note,
      Flag: this.flag,
      Deleted: this.deleted,
      LastModified: this.lastModified,
    };
  }

  static fromApiFormat(api) {
    return new SystemNote({
      id: api.ID,
      systemID: api.SystemID,
      title: api.Title,
      note: api.Note,
      flag: api.Flag,
      deleted: api.Deleted,
      lastModified: api.LastModified,
    });
  }
}

export default SystemNote;
